import { createFileRoute } from "@tanstack/react-router";
import AdminSigninAttempts from "@/pages/AdminSigninAttempts";

export const Route = createFileRoute("/admin/security/signin-attempts/")({
  component: AdminSigninAttempts,
});
